import React, { useRef } from 'react';
import { StaticQuery, graphql } from 'gatsby';

import { useScrolledIntoView } from 'utils/hooks/useScrolledIntoView';

import TextTeaser from 'components/common/TextTeaser';
import { PosedTarget } from 'components/common/Posed';

import { VideoWrapperPosed } from './StagePosed';

import {
  StageStyled,
  StageImageStyled,
  StageContentStyled,
  BackgroundStyled,
  BackgroundImageStyled,
  StageContentInnerStyled,
  MediaBoxStyled,
  MediaBoxMobileStyled,
  ImageStyled,
  VideoWrapperStyled,
  VideoStyled,
  GridHelperStyled,
} from './StageStyled';

function Stage({
  image,
  video,
  headline,
  tagline,
  children,
  text,
  buttonLink,
  buttonText,
  buttonTarget,
  backgroundContentImage,
  newsStage,
}) {
  const scrollCheckTarget = useRef(null);
  const [hasScrolledIntoView] = useScrolledIntoView({
    target: scrollCheckTarget,
  });

  return (
    <PosedTarget ref={scrollCheckTarget}>
      <StageStyled>
        <StageContentStyled newsStage={newsStage}>
          <BackgroundStyled>
            <BackgroundImageStyled src={backgroundContentImage} altText="Hintergrund" />
          </BackgroundStyled>
          <GridHelperStyled>
            <StageContentInnerStyled newsStage={newsStage}>
              <TextTeaser
                tagline={tagline}
                headline={headline}
                text={text}
                buttonPrimaryLink={buttonLink}
                buttonPrimaryText={buttonText}
                buttonPrimaryTarget={buttonTarget}
                hasScrolledIntoView={hasScrolledIntoView}
                textMaxWidth={420}
                isHeadlineLarge
              />

              <MediaBoxMobileStyled>
                {image && (
                  <ImageStyled
                    fluid={image?.[0]}
                    args={{ maxWidth: 800 }}
                    altText={image?.[0]?.altText}
                  />
                )}
              </MediaBoxMobileStyled>
            </StageContentInnerStyled>
            {children}
          </GridHelperStyled>
        </StageContentStyled>

        <StageImageStyled newsStage={newsStage}>
          <MediaBoxStyled>
            {image && !video?.[0]?.url && (
              <ImageStyled
                fluid={image?.[0]}
                args={{ maxWidth: 1200 }}
                altText={image?.[0]?.altText}
              />
            )}
            {video?.[0]?.url && (
              <VideoWrapperPosed key="video">
                <VideoWrapperStyled>
                  <VideoStyled
                    autoPlay='true'
                    muted
                    playsInline
                    loop
                  >
                    <source src={video?.[0]?.url} type="video/mp4" />
                  </VideoStyled>
                </VideoWrapperStyled>
              </VideoWrapperPosed>
            )}
          </MediaBoxStyled>
        </StageImageStyled>
      </StageStyled>
    </PosedTarget>
  );
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query StageQuery {
        stageContentBackground: file(
          relativePath: { eq: "warsteiner-stage-content-bg.jpg" }
        ) {
          ...imageDefault
        }
      }
    `}
    render={(data) => (
      <Stage backgroundContentImage={data?.stageContentBackground} {...props} />
    )}
  />
);
